<template>
  <ul class="social-nav-header navbar-nav">
    <li
        v-for="(itemSocialMenuPage, index) in socialMenuPage"
        :key="index"
        class="nav-item scc-nav-item"
    >
      <a :href="itemSocialMenuPage.href" class="nav-link hover-item-a" target="_blank" v-html="itemSocialMenuPage.svg" />
    </li>
  </ul>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "socialMenu",
  data(){
    return {
      socialMenuPage: {},
    }
  },
  computed: {
    ...mapState({
      socialMenu: state => state.settingsAndCustomize.siteCustomizationData.socialMenu.socialMenuPage,
    })
  },
  created() {
    this.socialMenuPage = this.socialMenu
    Object.keys(this.socialMenuPage).forEach((index) => {
      if (this.socialMenuPage[index].href === ''){
        delete this.socialMenuPage[index]
      }
    }, this.socialMenuPage)
  }
}
</script>

<style scoped>
.hover-item-a svg {
  height: 80%;
}
.social-nav-header{
  flex-direction: row;
}
.social-nav-header a {
  width: 20px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  margin: 0 5px;
}
.social-nav-header a svg path {
  fill: #adb5bd;
}
@media (max-width: 1199.98px) {
  .social-nav-header a {
    width: 26px;
    height: 26px;
    border-radius: 13px;
  }
}
</style>
